import {
  FETCH_SUMMARY_INSPECTIONS_INIT,
  FETCH_SUMMARY_INSPECTIONS_SUCCESS,
  FETCH_SUMMARY_INSPECTIONS_FAILURE,
  FETCH_SUMMARY_INSPECTIONS_FILTER_INIT,
  FETCH_SUMMARY_INSPECTIONS_FILTER_SUCCESS,
  FETCH_SUMMARY_INSPECTIONS_FILTER_FAILURE,
  FETCH_SUMMARY_INSPECTIONS_MODAL_INIT,
  FETCH_SUMMARY_INSPECTIONS_MODAL_SUCCESS,
  FETCH_SUMMARY_INSPECTIONS_MODAL_FAILURE,
  FETCH_SUMMARY_INSPECTIONS_MODALIMG_INIT,
  FETCH_SUMMARY_INSPECTIONS_MODALIMG_SUCCESS,
  FETCH_SUMMARY_INSPECTIONS_MODALIMG_FAILURE,
  FETCH_SUMMARY_INSPECTIONS_NO_LOADING_SUCCESS,
  FETCH_SUMMARY_INSPECTIONS_NO_LOADING_FAILURE,
  FETCH_SUMMARY_INSPECTIONS_NO_LOADING_INIT,
  RESET_MODAL,
  SET_FILTER_SUMMARY_INSPECTIONS,
  RESET_SUMMARY_INSPECTIONS,
  FETCH_SUMMARY_INSPECTIONS_COUNT_INIT,
  FETCH_SUMMARY_INSPECTIONS_COUNT_SUCCESS,
  FETCH_SUMMARY_INSPECTIONS_COUNT_FAILURE,
  FETCH_DOWNLOAD_INSPECTIONS_SUCCESS,
  FETCH_DOWNLOAD_INSPECTIONS_FAILURE,
  FETCH_DOWNLOAD_INSPECTIONS_INIT
} from './types';
import API from './api';

/* Actions Creators */

export function setFilterSummaryInspections(obj) {
  return {
    type: SET_FILTER_SUMMARY_INSPECTIONS,
    payload: obj
  };
}

export function resetSummaryInspections() {
  return {
    type: RESET_SUMMARY_INSPECTIONS
  };
}

/* Reset Modal */
export function resetModal() {
  return {
    type: RESET_MODAL
  };
}

// API that fetches the data from summary insp
function fetchApiSuccess(data) {
  return {
    type: FETCH_SUMMARY_INSPECTIONS_SUCCESS,
    payload: data
  };
}

function fetchApiFailure(error) {
  console.log(error);
  return {
    type: FETCH_SUMMARY_INSPECTIONS_FAILURE,
    payload: error
  };
}

function fetchApiInit() {
  return {
    type: FETCH_SUMMARY_INSPECTIONS_INIT
  };
}

export function fetchSummaryInspectionsApi(obj) {
  return async dispatch => {
    dispatch(fetchApiInit());
    try {
      let data = await API.data.getAll(obj);
      dispatch(fetchApiSuccess(data));
    } catch (error) {
      dispatch(fetchApiFailure(error));
    }
  };
}

// API that fetches data from summary insp filter
function fetchApiFilterSuccess(data) {
  return {
    type: FETCH_SUMMARY_INSPECTIONS_FILTER_SUCCESS,
    payload: data
  };
}

function fetchApiFilterFailure(error) {
  return {
    type: FETCH_SUMMARY_INSPECTIONS_FILTER_FAILURE,
    payload: error
  };
}

function fetchApiFilterInit() {
  return {
    type: FETCH_SUMMARY_INSPECTIONS_FILTER_INIT
  };
}

export function fetchSummaryInspectionsFilterApi(obj) {
  return async dispatch => {
    dispatch(fetchApiFilterInit());
    try {
      let data = await API.data.getFilter(obj);
      dispatch(fetchApiFilterSuccess(data));
    } catch (error) {
      dispatch(fetchApiFilterFailure(error));
    }
  };
}

// API that fetches the data from summary modal detail
function fetchApiModalSuccess(data) {
  return {
    type: FETCH_SUMMARY_INSPECTIONS_MODAL_SUCCESS,
    payload: data
  };
}

function fetchApiModalFailure(error) {
  return {
    type: FETCH_SUMMARY_INSPECTIONS_MODAL_FAILURE,
    payload: error
  };
}

function fetchApiModalInit() {
  return {
    type: FETCH_SUMMARY_INSPECTIONS_MODAL_INIT
  };
}

export function fetchSummaryInspectionsModalApi(obj) {
  return async dispatch => {
    dispatch(fetchApiModalInit());
    try {
      let data = await API.data.getModal(obj);
      dispatch(fetchApiModalSuccess(data));
    } catch (error) {
      dispatch(fetchApiModalFailure(error));
    }
  };
}

/* API modal img */
function fetchApiModalImgSuccess(data) {
  return {
    type: FETCH_SUMMARY_INSPECTIONS_MODALIMG_SUCCESS,
    payload: data
  };
}

function fetchApiModalImgFailure(error) {
  return {
    type: FETCH_SUMMARY_INSPECTIONS_MODALIMG_FAILURE,
    payload: error
  };
}

function fetchApiModalImgInit() {
  return {
    type: FETCH_SUMMARY_INSPECTIONS_MODALIMG_INIT
  };
}

export function fetchSummaryInspectionsModalImgApi(obj) {
  return async dispatch => {
    dispatch(fetchApiModalImgInit());
    try {
      let data = await API.data.getModalImg(obj);
      dispatch(fetchApiModalImgSuccess(data));
    } catch (error) {
      dispatch(fetchApiModalImgFailure(error));
    }
  };
}

/*  No loading */

function fetchApiNoLoadingSuccess(data, concat) {
  return {
    type: FETCH_SUMMARY_INSPECTIONS_NO_LOADING_SUCCESS,
    payload: data,
    concat
  };
}

function fetchApiNoLoadingFailure(error) {
  return {
    type: FETCH_SUMMARY_INSPECTIONS_NO_LOADING_FAILURE,
    payload: error
  };
}

function fetchApiNoLoadingInit() {
  return {
    type: FETCH_SUMMARY_INSPECTIONS_NO_LOADING_INIT
  };
}

export function fetchSummaryInspectionsNoLoadingApi(obj) {
  return async dispatch => {
    dispatch(fetchApiNoLoadingInit());
    try {
      let data = await API.data.getAll(obj);
      dispatch(fetchApiNoLoadingSuccess(data, obj.concat));
    } catch (error) {
      dispatch(fetchApiNoLoadingFailure(error));
    }
  };
}

/* COUNT */

function fetchApiCountSuccess(data) {
  return {
    type: FETCH_SUMMARY_INSPECTIONS_COUNT_SUCCESS,
    payload: data
  };
}

function fetchApiCountFailure(error) {
  return {
    type: FETCH_SUMMARY_INSPECTIONS_COUNT_FAILURE,
    payload: error
  };
}

function fetchApiCountInit() {
  return {
    type: FETCH_SUMMARY_INSPECTIONS_COUNT_INIT
  };
}

export function fetchSummaryInspectionsCountApi(obj) {
  return async dispatch => {
    dispatch(fetchApiCountInit());
    try {
      let data = await API.data.getCount(obj);
      dispatch(fetchApiCountSuccess(data));
    } catch (error) {
      dispatch(fetchApiCountFailure(error));
    }
  };
}
/* get download file */

function fetchDownloadApiSuccess(data) {
  return {
    type: FETCH_DOWNLOAD_INSPECTIONS_SUCCESS,
    payload: data
  };
}

function fetchDownloadApiFailure(error) {
  console.log(error);
  return {
    type: FETCH_DOWNLOAD_INSPECTIONS_FAILURE,
    payload: error
  };
}

function fetchDownloadApiInit() {
  return {
    type: FETCH_DOWNLOAD_INSPECTIONS_INIT
  };
}

export function fetchDownloadApi(item) {
  return async dispatch => {
    dispatch(fetchDownloadApiInit());
    try {
      let data = await API.data.handleDownload(item);
      dispatch(fetchDownloadApiSuccess(data));
    } catch (error) {
      dispatch(fetchDownloadApiFailure(error));
    }
  };
}



// WEBPACK FOOTER //
// ./source/client/actions/summary_inspections/index.js